import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/bak/documentation/general-terms')({
  component: () => <Navigate replace search to="/bo/documentation/general-terms" />,
})
